import api from './axiosConfig';

export type StockSearchSuggestion = {
  ticker: string;
  corpName: string;
  market?: string | null;
  closePrice?: number | null;
  priceChangePct?: number | null;
  tradingValue?: number | null;
  decisionLabel?: string | null;
  decisionTone?: string | null;
};

function normalizeRows(data: any): StockSearchSuggestion[] {
  const rows = Array.isArray(data)
      ? data
      : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.data)
              ? data.data
              : [];

  return rows
  .map((row: any) => ({
    ticker: String(row?.ticker ?? row?.stockCode ?? row?.stock_code ?? '').trim(),
    corpName: String(row?.corpName ?? row?.corp_name ?? row?.name ?? '').trim(),
    market: row?.market ?? null,
    closePrice: row?.closePrice ?? row?.close_price ?? row?.close ?? null,
    priceChangePct: row?.priceChangePct ?? row?.price_change_pct ?? row?.price_change_percentage ?? null,
    tradingValue: row?.tradingValue ?? row?.trading_value ?? null,
    decisionLabel: row?.decisionLabel ?? row?.decision_label ?? null,
    decisionTone: row?.decisionTone ?? row?.decision_tone ?? null,
  }))
  .filter((row: StockSearchSuggestion) => /^\d{6}$/.test(row.ticker) && !!row.corpName);
}

export async function searchStockSuggestions(q: string, limit = 10): Promise<StockSearchSuggestion[]> {
  const keyword = String(q || '').trim();
  if (!keyword) return [];

  const res = await api.get('/stocks/search', {
    params: {
      q: keyword,
      limit,
    },
  });

  return normalizeRows(res?.data);
}
